
'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';

const $ = jQuery.noConflict();
$(function() {

	const contactForm = {

		init: function() {
			cf7Helpers.afterFormSubmit();
			cf7Helpers.preventNumTelInputsTypeLetters();
		}
	};

	contactForm.init();
});
